module.exports = __webpack_public_path__ + "static/media/bt_bg_14.e42c055d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bt_bg_14.png
// module id = 1741
// module chunks = 0 1